import * as index_py from './index.py'
import * as server_py from './server.py'

export default [index_py, server_py]
